import { render, staticRenderFns } from "./utiles-detalles-publicacion-notas.vue?vue&type=template&id=36bbb4c0&scoped=true&"
import script from "./utiles-detalles-publicacion-notas.vue?vue&type=script&lang=ts&"
export * from "./utiles-detalles-publicacion-notas.vue?vue&type=script&lang=ts&"
import style0 from "./utiles-detalles-publicacion-notas.vue?vue&type=style&index=0&id=36bbb4c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bbb4c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDivider,VList,VListItem,VRow,VSkeletonLoader,VSpacer,VTextField})
